import { Module } from '@nestjs/common';
import { PrismaModule } from '../prisma/prisma.module';
import { ContabilidadModule } from '../contabilidad/contabilidad.module';
import { SupervisoresController } from './supervisores.controller';
import { SupervisoresService } from './supervisores.service';

@Module({
  imports: [PrismaModule, ContabilidadModule],
  controllers: [SupervisoresController],
  providers: [SupervisoresService],
  exports: [SupervisoresService],
})
export class SupervisoresModule {}
